import DatePickerInput from "../ui/DatePickerInput";
import FromToInput from "../ui/FromToInput";
import TimePickerInput from "../ui/TimePickerInput";
import TextAreaInput from "../ui/TextAreaInput";
// import SelectInput from "../ui/SelectInput";
import getClassName from "../../utilities/getClassName";
import { setMinDate, setMaxDate, setMinTime } from "../../utilities/date";
import { canDeleteJourneyLeg, getLegIconName } from "../../utilities/quoteQueryJets";
import PassengerDropdown from "../manage-passengers/PassengerDropdown";
import LuggageDropdown from "./LuggageDropdown";
import personIcon from "../../assets/icons/person-dark.svg";
import luggageIcon from "../../assets/icons/luggage-dark.svg";
import closeCrossDark from "../../assets/icons/close-cross-dark-heavy.svg";
import { getIcon, getRawIcon } from "../../utilities/icon";

const QuoteQueryJourneyRow = ({
    journey,
    index,
    journeyData,
    tripType,
    resetFormRef,
    validateForm,
    onFocus,
    skeleton,
    inModal,
    updateInputHandler,
    removeJourneyHandler,
    getCopiedProperty,
    getCopiedDate,
    setRequests,
    openDropdownId,
    setOpenDropdownId,
    location,
    poweredByCtx,
    onPage,
    isScrolled,
}) => {
    const showDelete = canDeleteJourneyLeg(journeyData.length, tripType);
    const deleteIconName = getLegIconName("remove-leg", {
        onPage,
        isScrolled,
        isPoweredBy: poweredByCtx?.isPoweredBy,
    });

    return (
        <div
            key={journey.id}
            className={getClassName(["quote-query__inputs", showDelete && "quote-query__inputs--with-delete"])}
        >
            <div className="quote-query__inputs__column">
                <FromToInput
                    value={(fromValue) => updateInputHandler(index, "flightFrom", fromValue)}
                    defaultValue={journey.flightFrom}
                    direction="from"
                    label="From"
                    required={true}
                    errorOnBlur={false}
                    altErrorStyle={true}
                    validateForm={validateForm}
                    onFocus={onFocus}
                    copiedProperty={getCopiedProperty("flightFrom", index)}
                    key={`from-${resetFormRef}`}
                    skeleton={skeleton}
                />
            </div>
            <div className="quote-query__inputs__column">
                <FromToInput
                    value={(toValue) => updateInputHandler(index, "flightTo", toValue)}
                    defaultValue={journey.flightTo}
                    direction="to"
                    label="To"
                    required={true}
                    errorOnBlur={false}
                    validateForm={validateForm}
                    onFocus={onFocus}
                    copiedProperty={getCopiedProperty("flightTo", index)}
                    key={`to-${resetFormRef}`}
                    skeleton={skeleton}
                />
            </div>
            <div
                className={getClassName([
                    "quote-query__inputs__column",
                    "quote-query__inputs__column--medium-width",
                    (index === 0 || tripType === "returns") && "quote-query__inputs__column--time-and-date",
                ])}
            >
                <DatePickerInput
                    value={(dateValue) => updateInputHandler(index, "date", dateValue)}
                    defaultValue={journey.date}
                    label="Date"
                    required={true}
                    errorOnBlur={false}
                    validateForm={validateForm}
                    onFocus={onFocus}
                    copiedProperty={getCopiedDate(index)}
                    inModal={inModal}
                    key={`date-${resetFormRef}`}
                    skeleton={skeleton}
                    minDate={setMinDate(index, journeyData)}
                    maxDate={setMaxDate(index, journeyData)}
                />
            </div>
            <div className="quote-query__inputs__column quote-query__inputs__column--medium-width">
                <TimePickerInput
                    is24Hour={location?.country !== "US"}
                    value={(timeValue) => updateInputHandler(index, "time", timeValue)}
                    defaultValue={journey.time}
                    label="Time"
                    required={true}
                    errorOnBlur={false}
                    validateForm={validateForm}
                    onFocus={onFocus}
                    copiedProperty={getCopiedProperty("departureTime", index)}
                    minTime={setMinTime(index, journeyData, location?.country !== "US")}
                    key={`time-${resetFormRef}`}
                    skeleton={skeleton}
                />
            </div>
            <div className="quote-query__inputs__column quote-query__inputs__column--shared">
                <PassengerDropdown
                    id={`passengers-${index}`}
                    icon={personIcon}
                    defaultValue={journey.passengers}
                    value={(passengersValue) => updateInputHandler(index, "passengers", passengersValue)}
                    validateForm={validateForm}
                    onFocus={onFocus}
                    classNames={["passenger-dropdown--flight-enquiry", "passenger-dropdown--full"]}
                    key={`passengers-${resetFormRef}`}
                    skeleton={skeleton}
                    min={1}
                    max={99}
                    isOpen={openDropdownId === `passengers-${index}`}
                    onToggle={(id, isOpen) => setOpenDropdownId(isOpen ? id : null)}
                />
                <LuggageDropdown
                    id={`luggage-${index}`}
                    icon={luggageIcon}
                    defaultValue={journey.luggage}
                    defaultCarryOn={journey.carryOn}
                    value={({ bags, carryOn }) => {
                        updateInputHandler(index, "luggage", bags);
                        updateInputHandler(index, "carryOn", carryOn);
                    }}
                    validateForm={validateForm}
                    onFocus={onFocus}
                    classNames={["luggage-dropdown--flight-enquiry", "luggage-dropdown--full"]}
                    key={`luggage-${resetFormRef}`}
                    skeleton={skeleton}
                    min={0}
                    max={99}
                    isOpen={openDropdownId === `luggage-${index}`}
                    onToggle={(id, isOpen) => setOpenDropdownId(isOpen ? id : null)}
                />
                {/*
                <SelectInput
                    icon={personIcon}
                    defaultValue={journey.passengers}
                    options={numbersList}
                    value={(passengersValue) => updateInputHandler(index, "passengers", passengersValue)}
                    chevron={chevronDown}
                    classNames={["select-input--flight-enquiry", "select-input--full"]}
                    validateForm={validateForm}
                    onFocus={onFocus}
                    copiedProperty={getCopiedProperty("passengers")}
                    key={`passengers-${resetFormRef}`}
                    skeleton={skeleton}
                    min={1}
                    max={99}
                    isOpen={openDropdownId === `passengers-${index}`}
                    onToggle={(id, isOpen) => setOpenDropdownId(isOpen ? id : null)}
                />
                <SelectInput
                    icon={luggageIcon}
                    defaultValue={journey.luggage}
                    options={numbersList}
                    value={(luggageValue) => updateInputHandler(index, "luggage", luggageValue)}
                    chevron={chevronDown}
                    classNames={["select-input--flight-enquiry", "select-input--full"]}
                    validateForm={validateForm}
                    onFocus={onFocus}
                    copiedProperty={getCopiedProperty("luggage")}
                    key={`luggage-${resetFormRef}`}
                    skeleton={skeleton}
                    min={0}
                    max={99}
                    isOpen={openDropdownId === `luggage-${index}`}
                    onToggle={(id, isOpen) => setOpenDropdownId(isOpen ? id : null)}
                />
                */}
            </div>
            {inModal && (
                <TextAreaInput
                    id="requests"
                    maxLength={2000}
                    showCharacterCount
                    label="Requests e.g. pets… (optional)"
                    value={(value) => setRequests(value)}
                    key={`requests-${resetFormRef}`}
                />
            )}
            {showDelete && (
                <button
                    type="button"
                    onClick={() => removeJourneyHandler(index)}
                    className="quote-query__delete-button"
                >
                    {inModal ? (
                        <img alt="" src={closeCrossDark} />
                    ) : (
                        <>
                            {poweredByCtx?.isPoweredBy ? (
                                <>{getRawIcon("remove-leg")}</>
                            ) : (
                                <img alt="" src={getIcon(deleteIconName)} />
                            )}
                        </>
                    )}
                    Delete
                </button>
            )}
        </div>
    );
};

export default QuoteQueryJourneyRow;
